module.exports = __webpack_public_path__ + "icon_sprite.a3785616014190f29310.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/Administrator/submit text project/gwin/src/assets/img/icon_sprite.png
// module id = ../../../../../src/assets/img/icon_sprite.png
// module chunks = 4